(function() {
    'use strict';
    angular
        .module('c3WebApp')
        .factory('AccessToken', AccessToken);

    AccessToken.$inject = ['$resource'];

    function AccessToken ($resource) {
        var resourceUrl =  'api/access-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
